import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { apiService } from 'app/services/api.service';
import { Languages } from 'app/classes/languages';

import { TranslateService } from '@ngx-translate/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import { CustomModalComponent } from '@shared/custom-modal/custom-modal.component';
import { globalData } from '../../services/globalData.service';
import { Router } from '@angular/router';
import { B2cGlobalDataService } from 'app/services/b2cGlobalData.service';
import { HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Output() toggleTextDirectionEvent = new EventEmitter<boolean>();
  sitePhone: string = '';

  modalEvent($event: Event) {
    throw new Error('Method not implemented.');
  }

  private modalRef: BsModalRef;


  myForm?: UntypedFormGroup;
  isRtl: boolean;
  languageLists: Languages[];
  languageCode: string;
  currencies: any;
  whiteLogo: string;
  colorLogo: string;
  arabicLogo: string;


  constructor(private _apiService: apiService,
    private translate: TranslateService,
    private formBuilder: UntypedFormBuilder,
    private modalService: BsModalService,
    private router: Router,
    private b2cGlobalDataService: B2cGlobalDataService,
    public global: globalData) {
    // Check local storage for text direction preference


    if (localStorage.getItem('languageCode') == null) {
      this.global.GetArabicCountries().then((arabicCountryCodes: any) => {
        this.global.getGeoLocationByIP().then((countryCodes: any) => {
          if (localStorage.getItem('isLanguageCodeChange') == null) {
            if (arabicCountryCodes.includes(this.global.customerCountryCode)) {
              this.languageCode = 'ar';
            }
            else {
              this.languageCode = 'en'
            }
            localStorage.setItem('languageCode', this.languageCode);
            this.languageCode = String(localStorage.getItem('languageCode'));
            this.isRtl = this.languageCode && this.languageCode == 'ar' ? true : false;
            this.updateTextDirection(this.languageCode && this.languageCode == 'ar' ? true : false);
            this.translate.use(this.languageCode);
          }
        });
      });
    } else {
      this.languageCode = String(localStorage.getItem('languageCode'));
      this.isRtl = this.languageCode && this.languageCode == 'ar' ? true : false;
      this.updateTextDirection(this.languageCode && this.languageCode == 'ar' ? true : false);
      this.translate.use(this.languageCode);
    }
  }

  config = {
    backdrop: true,
    ignoreBackdropClick: true,
    class: "my-login-modal modal-dialog-centered",
  };
  ngOnInit(): void {
    this.b2cGlobalDataService.login().subscribe(response => {
      // Handle the API response here
      console.log(response);
    }, error => {
      // Handle errors
      console.error(error);
    });

    this.b2cGlobalDataService.checkTokenValidity().subscribe(response => {
      // Handle the API response for token validity check here
      console.log(response);
    }, error => {
      // Handle errors
      console.error(error);
    });

    this._apiService.getGeneral().subscribe(
      (data: any) => {
        if (data && data.success === 1 && data.data && data.data.sitePhone) {
          this.sitePhone = data.data.sitePhone;
          if (data.data.whiteLogo) {
            this.whiteLogo = data.data.whiteLogo;
          }
          if (data.data.colorLogo) {
            this.colorLogo = data.data.colorLogo;
          }
          if (data.data.arabicLogo) {
            this.arabicLogo = data.data.arabicLogo;
          }
        }
      },
      (error: any) => {
        console.error('Error fetching general data', error);
      }
    );

    const body = document.querySelector('body');
    if (this.languageCode == 'en') {
      this.myForm = this.formBuilder.group({
        radio: 'en'
      });
    }
    else {
      body?.classList.add('rtl-direction');
      this.myForm = this.formBuilder.group({
        radio: 'ar'
      });
    }
    this._apiService.getLanguages()
      .subscribe(
        data => {
          this.languageLists = data.data;
        }
      )

    this._apiService.getCurrencies()
      .subscribe(
        data => {
          this.currencies = data.data.allow_cur;
          let localDisplayCurrency = localStorage.getItem('displayCurrency');
          if (localDisplayCurrency != null) {
            this.defaultDisplayCurrency = localDisplayCurrency;
          } else {
            this.defaultDisplayCurrency = data.data.default_display_cur.code;
            localStorage.setItem('displayCurrency', data.data.default_display_cur.code);
            localStorage.setItem('displayCurrencySymbol', data.data.default_display_cur.symbol);
          }
        }
      )

    this._apiService.getTranslation(this.languageCode)
      .subscribe(
        data => {

        }
      )
  }


  openModal() {

    this.modalRef = this.modalService.show(CustomModalComponent, this.config);
    this.modalRef.onHide.subscribe((reason: string | any) => {
      if (reason === 'backdrop-click') {

      }
    });
  };

  showLoader: boolean = true;

  toggleTextDirection(isRtl: boolean): void {
    if (this.isRtl === isRtl) {
      return;
    }

    this.isRtl = isRtl;
    this.updateTextDirection(this.isRtl);
    localStorage.setItem('isLanguageCodeChange', '1');

    if (this.isRtl) {
      this.languageCode = 'ar';
    } else {
      this.languageCode = 'en';
    }
    localStorage.setItem('languageCode', this.languageCode);
    // Hide the loader when the translation is toggled
  this.showLoader = false;

  // Save the information in local storage
  localStorage.setItem('hideLoaderOnTranslationToggle', 'true');

  // Use a setTimeout to delay the reload and allow the UI to update
  setTimeout(() => {
    // Trigger page reload
    window.location.reload();
  }, 0);

  }

  updateTextDirection(isRtl: boolean): void {
    const htmlElement = document.getElementsByTagName('html')[0];
    if (isRtl) {
      htmlElement.setAttribute('dir', 'rtl');
      htmlElement.setAttribute('lang', 'ar'); // Set the language to Arabic
    } else {
      htmlElement.setAttribute('dir', 'ltr');
      htmlElement.setAttribute('lang', 'en'); // Set the language to English
    }
  }

  getImageSrc() {
    const isRtl = document.dir === 'rtl';

    // Define image sources for RTL and LTR directions
    const rtlImageSrc = this.arabicLogo ? this.arabicLogo : 'assets/image/logo-ar.png';
    const ltrImageSrc = this.whiteLogo ? this.whiteLogo : 'assets/image/logo.png';

    // Return the appropriate image source based on document direction
    return isRtl ? rtlImageSrc : ltrImageSrc;
  }


  defaultDisplayCurrency: string = "SAR";
  colorvariable: number = 0;
  contentdropdown: boolean = false;


  changeCode(arr: any) {
    this.defaultDisplayCurrency = arr.code;
    this.colorvariable = arr.id;
    localStorage.setItem('displayCurrency', arr.code);
    localStorage.setItem('displayCurrencySymbol', arr.symbol);
    location.reload();
  }

  dropdownOpen() {
    this.contentdropdown = !this.contentdropdown;
  }
}
